import React from "react";
import ClarkMachineCard from "./clarkMachineCard";

const ElectricForklifts = () => {
  return (
    <div className="w-full mt-5">
      <h4 className="mt-8 text-xl">Čelní elektrické čtyřkolové vozíky</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-se16-20s.webp"
          imgAlt="Obrázek čelního elektrického čtyřkolového vozíku CLARK se16-20s"
          title="CLARK série SE16/20"
          loadCapacity="1 600 - 2 000 kg"
          drive="Elektrický"
          liftHeight="2 795 - 7 075 mm"
          maxSpeed="až 16 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/se16-20?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-exp20i-32i.webp"
          imgAlt="Obrázek čelního elektrického čtyřkolového vozíku CLARK exp20i-32i"
          title="CLARK série EPX20i/22i/25i/30i/32i"
          loadCapacity="2 000 - 3 200 kg"
          drive="Elektrický"
          liftHeight="1 985 - 7 315 mm"
          maxSpeed="až 16 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/epx20i-22i-25i-30i-32i?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-se25-35.webp"
          imgAlt="Obrázek čelního elektrického čtyřkolového vozíku CLARK se25-35"
          title="CLARK série SE25/30s/30/35"
          loadCapacity="2 500 - 3 500 kg"
          drive="Elektrický"
          liftHeight="1 985 - 7 315 mm"
          maxSpeed="až 20 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/se25-30s-30-35?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-gex40-50.webp"
          imgAlt="Obrázek čelního elektrického čtyřkolového vozíku CLARK gex40-50"
          title="CLARK série GEX40/45/50"
          loadCapacity="4 000 - 4 990 kg"
          drive="Elektrický"
          liftHeight="1 985 - 7 315 mm"
          maxSpeed="až 11.3 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/gex40-45-50?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>

      <h4 className="mt-8 text-xl">Čelní elektrický tříkolový vozík</h4>
      <div className="grid grid-cols-1 gap-4 mt-2 sm:grid-cols-2 mdPlus:grid-cols-3 2xl:grid-cols-4">
        <ClarkMachineCard
          imgSrc="/images/ClarkOverview/clark-nove-ste16-20.webp"
          imgAlt="Obrázek čelního elektrického tříkolového vozíku CLARK ste16-20"
          title="CLARK série STE16/18/20"
          loadCapacity="1 600 - 2 000 kg"
          drive="Elektrický"
          liftHeight="2 795 - 7 075 mm"
          maxSpeed="až 16 km/h"
          link="https://clarkmheu-com.translate.goog/en/electric-forklifts/ste16-18-20?tmpl=component&iframe=true&test=1&_x_tr_sl=auto&_x_tr_tl=cs&_x_tr_hl=cs&_x_tr_pto=wapp"
        />
      </div>
    </div>
  );
};
export default ElectricForklifts;
